import {
	EmbeddedVideo,
	type EmbeddedVideoType,
} from '@/libraries/design/components/embedded-video/src/embedded-video';

export interface UniformEmbeddedVideoProps {
	url: string;
	title?: string;
	thumbnailSrc?: string;
	thumbnailAlt?: string;
	videoType?: EmbeddedVideoType;
	roundedCorners?: boolean;
	aspectRatio?: string;
}

const UniformEmbeddedVideo = ({
	url,
	title,
	thumbnailSrc,
	thumbnailAlt = '',
	videoType,
	roundedCorners,
	aspectRatio,
}: UniformEmbeddedVideoProps) => {
	return (
		<EmbeddedVideo
			embedUrl={url}
			title={title}
			thumbnail={{
				src: thumbnailSrc ? thumbnailSrc : '',
				alt: thumbnailAlt,
			}}
			dataEventProps={{
				'data-product-key': 'uniform',
				'data-event-component': 'embeddedVideo',
				'data-event-container': 'video',
				'data-event': 'clicked',
				'data-track-event': 'videoPlayed',
			}}
			videoType={videoType || undefined}
			roundedCorners={roundedCorners}
			aspectRatio={aspectRatio}
		/>
	);
};

export default UniformEmbeddedVideo;
